import { IPrayerTimesState } from "./index";
import { IRootState } from "./CombineReducer";
import { IDuasState } from "./DuasSlice";
import { IConfigurationState } from "./ConfigurationSlice";

export const getPrayerTimesState = (root: IRootState): IPrayerTimesState =>
  root.prayerTimes;
export const getDuasState = (root: IRootState): IDuasState => root.dailyDuas;
export const getConfigurationState = (root: IRootState): IConfigurationState =>
  root.configuration;
